class CartRecommendationsComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const minProducts = 4;
    
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(
          "#shopify-section-cart-recommendations"
        );
        
        if (recommendations) {
          const items = recommendations.querySelectorAll(".f-cart-recommendations__item");
          
          if (items.length > 0) {
            this.innerHTML = recommendations.innerHTML;
            
            // If not enough products, fetch more from collection
            if (items.length < minProducts) {
              this.fetchFallbackProducts(items.length, minProducts);
            }
          }
        }
      })
      .catch((err) => console.error(err));
  }

  fetchFallbackProducts(currentCount, minNeeded) {
    const needed = minNeeded - currentCount;
    
    // Get product IDs already shown to exclude them
    const existingIds = [];
    this.querySelectorAll('.f-cart-recommendations__item').forEach(item => {
      const link = item.querySelector('a[href*="/products/"]');
      if (link) {
        const match = link.href.match(/\/products\/([^?\/]+)/);
        if (match) existingIds.push(match[1]);
      }
    });
    
    // Also exclude the product this recommendation is for
    const urlParams = new URLSearchParams(this.dataset.url.split('?')[1]);
    const currentProductId = urlParams.get('product_id');
    
    // Fetch products from /collections/all
    fetch('/collections/all/products.json?limit=20')
      .then(response => response.json())
      .then(data => {
        const slider = this.querySelector('flickity-component');
        if (!slider || !data.products) return;
        
        let added = 0;
        
        for (const product of data.products) {
          if (added >= needed) break;
          
          // Skip if already shown or is current product
          if (existingIds.includes(product.handle)) continue;
          if (product.id == currentProductId) continue;
          
          // Create product card HTML
          const productCard = this.createProductCard(product);
          slider.insertAdjacentHTML('beforeend', productCard);
          existingIds.push(product.handle);
          added++;
        }
        
        // Reinitialize Flickity if it exists
        if (slider.flickityInstance) {
          slider.flickityInstance.reloadCells();
        } else if (window.Flickity && slider.dataset.enableSlider === 'true') {
          // Try to trigger slider init
          slider.dispatchEvent(new Event('reload'));
        }
      })
      .catch(err => console.error('Fallback products fetch error:', err));
  }

  createProductCard(product) {
    const variant = product.variants[0];
    const price = variant.price;
    const formattedPrice = (price / 100).toFixed(2).replace('.', ',') + ' €';
    const image = product.images[0] ? product.images[0].src : '';
    const imageSmall = image ? image.replace(/\.([^.]+)$/, '_200x.$1') : '';
    
    return `
      <div class="f-cart-recommendations__item bg-secondary f-product-card f-product-card--list-layout color-background-1">
        <div class="f-product-card__wrapper">
          <div class="f-product-card__media relative f-image-hover-effect__">
            <a href="/products/${product.handle}" class="full-width-link"></a>
            <responsive-image class="f-image" style="--aspect-ratio: 1">
              <img src="${imageSmall}" alt="${product.title}" loading="lazy" width="200" height="200">
            </responsive-image>
          </div>
          <div class="f-product-card__info">
            <a class="f-product-card__title text-product-title" href="/products/${product.handle}">${product.title}</a>
            <div class="f-product-card__price">
              <div class="f-price">
                <dl>
                  <div class="f-price__regular">
                    <dd><span class="f-price-item f-price-item--regular">${formattedPrice}</span></dd>
                  </div>
                </dl>
              </div>
            </div>
            <add-to-cart-button class="f-cart-recommendations__add-btn" data-variant-id="${variant.id}">
              <button type="button" class="btn f-cart-recommendations__item-add-to-cart" aria-label="Add to cart">
                <svg class="icon icon-cart" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z" stroke-width="1.5"/>
                  <path d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z" stroke-width="1.5"/>
                  <path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6" stroke-width="1.5"/>
                </svg>
              </button>
            </add-to-cart-button>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define(
  "cart-recommendations-component",
  CartRecommendationsComponent
);

if (!customElements.get("add-to-cart-component")) {
  class AddToCartComponent extends HTMLElement {
    constructor() {
      super();

      this.cartDrawer = document.querySelector("cart-drawer");
      this.addToCartButton = this.querySelector(
        ".f-cart-recommendations__item-add-to-cart"
      );
      this.addEventListener("click", this.onSubmitHandler.bind(this));
    }

    onSubmitHandler() {
      this.addToCartButton.classList.add("btn--loading");
      const variantId = this.dataset.variantId;

      if (!variantId) return;

      const config = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);

      if (this.cartDrawer) {
        formData.append(
          "sections",
          this.cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
      }

      config.body = formData;

      fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return this.Notification.show({
              target: document.body,
              method: "appendChild",
              type: "warning",
              message: response.description,
              last: 3000,
              sticky: true,
            });
          }
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.addToCartButton.classList.remove("btn--loading");
        });
    }
  }
  customElements.define("add-to-cart-button", AddToCartComponent);
}